<template>
<div>

  <!-- SEARCH -->
<!--   
  <section>
    <b-field position="is-centered">
        <b-input placeholder="Search..." type="search" icon="magnify">
        </b-input>
        <p class="control">
            <button class="button is-info" @click="filterContacts">Search</button>
        </p>
    </b-field>
  </section>
  <br>
 -->


<!-- 
<b-field>
  <b-select placeholder="Select Contact" expanded  v-model="selected" @input="onSelectChange"
          :loading="!allContacts.length"
          @keypress.prevent icon="arrow-circle-right" icon-pack="fas">
    <option disabled value=null>Select an Contact</option>
    <option v-for="contact in allContacts"
            :value="contact" :key="contact.id">
      {{ contact.name }} 
    </option>
  </b-select>
</b-field> -->

  <b-field label="Select a group">
    <b-select placeholder="Select a group" v-model="selectedgroup" @input="onSelectedGroupChange"
      icon="arrow-circle-right" icon-pack="fas">
      <option value="All">All</option>
      <option disabled value="">--Customer Group--</option>
      <option
          v-for="option in segGroups"
          :value="option.name"
          :key="option.id">
          {{ option.name }}
      </option>
      <option disabled value="">--TAGS--</option>
      <option
          v-for="option in getAccount.ctags"
          :value="option"
          :key="option">
          {{ option}}
      </option>
    </b-select>
  </b-field>

<!-- {{selectedgroup}} -->

  <b-notification :closable="false" v-if="!allContacts.length">
      Loading Contacts
      <b-loading :is-full-page="false" :active.sync="!allContacts.length" :can-cancel="true"></b-loading>
  </b-notification>


    <div v-for="contact in localFilteredContacts" v-bind:key="contact.id">
      <a  @click="putSelectedContact(contact)" >
        <ListPanelItem :contact='contact' style="margin-bottom: 1em;"/>
      </a>
    </div>

    <!-- //// -->

    <!-- <div v-for="contact in allContacts" v-bind:key="contact.id">
      <a  @click="putSelectedContact(contact)" >
        <ListPanelItem :contact='contact' style="margin-bottom: 1em;"/>
      </a>
    </div> -->

</div>
</template>





<script>
import { SegGroups } from "@/utils/settings"
import ListPanelItem from '@/components/main/contact/ListPanelItem.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  

  name: 'ListPanel',
  components: {
    ListPanelItem
  },
  

  props: [
    'contact'
  ],

  data () {
    return {
      segGroups: SegGroups,
      selectedgroup: "All",
      localFilteredContacts: [],
      // searchstring: "",
      // myfilteredContacts: [],
      selected: null, //..by select UI
    }
  },

  created () {
    this.filterForGroups()
    // this.fetchContacts() 
  },
  computed: {
    ...mapGetters(['allContacts', 'selectedContact', 'getAccount']),
    // contactFromIndex () {
    //   return this.allContacts.find(contact => contact.id === this.selected)
    // },
  },
  // filter: {
  // },
  methods: {
    ...mapActions(['fetchContacts', 'putSelectedContact']),
    onSelectChange() {
      // console.log("triggerd")
      this.putSelectedContact(this.selected)
    },
    onSelectedGroupChange() {
      this.filterForGroups()
    },

    filterForGroups() {
      if (this.selectedgroup == "All") {
        this.localFilteredContacts = this.allContacts
      }

      for (var group of SegGroups) {
        if (this.selectedgroup === group.name) {
          this.localFilteredContacts = this.allContacts.filter(contact => contact.status.custclass == group.custclass)
          console.log("found> " + JSON.stringify(group))
          console.log("found length > " + this.localFilteredContacts.length)    
          return 
        }
      }

      for (var tag of this.getAccount.ctags) {
        if (this.selectedgroup === tag) {
          
          this.localFilteredContacts = this.allContacts.filter(contact => contact.status.tags.includes(tag) )
          console.log("found> " + JSON.stringify(tag))
          console.log("found length > " + this.localFilteredContacts.length)    
          return
        }
      }

      // console.log("found length > " + this.localFilteredContacts.length)    
    }
    // reloadContacts() {
    //   console.log("reload contacts")
    //   this.fetchContacts()
    // },
    // printAll() {
    //   var c = null
    //   for (c of this.allContacts) {
    //     console.log(c.id + " | "+ JSON.stringify(c.status))
    //   }
    // }

    // selectcontact(contact) {
    //   //  $store.commit('setSelectedContact', contact) //..calling mutataion -> changing state
    //   this.putSelectedContact(contact) //.. from mapAction

    //   // this.selected = contact.id;
    //   // this.$emit('input', this.selectedContact)
    // },
    // onChange () {
    //   // store.commit('setSelectedContact', this.selectedContact) //..calling mutataion -> changing state
    //   this.putSelectedContact(this.contactFromIndex)

    //   // this.$emit('input', this.selectedContact)
    //   // this.$emit('xxx', this.selectedContact)
    // }
  },
  watch: {
    allContacts () {
      this.filterForGroups()
    }
    // allContacts (newValue, oldValue) {
    //   // console.log(`Updating from ${oldValue} to ${newValue}`);
    //   // this.localSelectedContact = Object.assign({}, newValue)   //...make a copy of the object (even working with the original Object, it's needed) !!! important to make it reactive !!!???
    //   // this.localSelectedContact = newValue
    // }
  }
  

}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>